import { Card } from '../ui';

type Props = {
  opportunities?: string[];
  risks?: string[];
};

export function OpportunityRiskPanels({ opportunities = [], risks = [] }: Props) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card padding="sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-success-600">AI Opportunity Center</p>
        <ul className="mt-3 space-y-2">
          {opportunities.map((o) => (
            <li key={o} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
              <span className="mt-0.5 text-success-500" aria-hidden="true">↑</span>
              {o}
            </li>
          ))}
        </ul>
      </Card>
      <Card padding="sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-error-600">AI Risk Center</p>
        <ul className="mt-3 space-y-2">
          {risks.map((r) => (
            <li key={r} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
              <span className="mt-0.5 text-error-500" aria-hidden="true">!</span>
              {r}
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
